import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint';
import StarWithoutBg from 'assets/Icons/StarWithoutBg';
import React, { FC } from 'react';
import { twMerge } from 'tailwind-merge';

import ProductDropdown from '@/components/Layout/ProductDropdown';
import { HeaderLink, ILinks } from '@/components/Layout/ProductsHeader';
interface Props {
  shouldRenderLinks: boolean;
  links: ILinks[];
  timeoutIdRef: React.MutableRefObject<NodeJS.Timeout | null>;
  setHoveredIndex: React.Dispatch<React.SetStateAction<number | null>>;
  setOpenDropDown: React.Dispatch<React.SetStateAction<boolean>>;
  openZaiDrawer: () => void;
  openDropDown: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  hoveredIndex: number | null;
  isZai: boolean;
  isPdf: boolean;
}

const ZaiButton = () => {
  return (
    <div className='relative inline-flex isolate rounded-[6px] p-[1px] overflow-hidden cursor-pointer xl:h-[40px] sm:h-[32px] h-[36px] transition-all sm:hover:scale-105 sm:hover:translate-y-[1px] sm:active:scale-95 active:scale-95 transform-gpu will-change-transform'>
      <div className='absolute inset-[-150%] spin-smooth'>
        <div
          className='absolute inset-0'
          style={{
            background:
              'conic-gradient(from 37deg at 50% 50%, #51A0F7, #7328F2, #7E0D9D, #51A0F7)',
          }}
        />
      </div>

      <div className='relative z-10 flex items-center gap-2 rounded-[6px] bg-black hover:bg-grayZl-950 ps-1.5 pe-[7px] py-[13px] text-white transition-all transform-gpu will-change-transform'>
        <StarWithoutBg width='14' />
        <span className='text-sm/[22px] font-semibold text-white'>
          <span className='text-xs/[22px]'>Z</span>AI
        </span>
      </div>
    </div>
  );
};

const Options: FC<Props> = ({
  hoveredIndex,
  setOpen,
  openDropDown,
  openZaiDrawer,
  setOpenDropDown,
  setHoveredIndex,
  links,
  timeoutIdRef,
  isZai,
  isPdf,
}) => {
  const screens = useBreakpoint();

  return (
    <span
      className={twMerge(
        'sm:ps-0 ps-4 no-scrollbar h-full md:flex relative flex xl:gap-x-2 gap-x-1 items-center w-full sm:justify-center justify-start sm:overflow-x-visible overflow-x-auto',
        isZai || isPdf
          ? 'sm:justify-start justify-start'
          : 'sm:justify-center justify-start',
      )}
    >
      {links.map((link, index) => {
        const isZai = link.type === 'zai';

        return (
          <div
            key={`${link.route}-${index}`}
            className='relative inline-block w-fit'
            {...(!isZai && {
              onMouseEnter: () => {
                if (timeoutIdRef.current) clearTimeout(timeoutIdRef.current);
                setHoveredIndex(index);
                setOpenDropDown(true);
              },
              onMouseLeave: () => {
                timeoutIdRef.current = setTimeout(() => {
                  setOpenDropDown(false);
                  setHoveredIndex(null);
                }, 100);
              },
            })}
            onClick={() => {
              if (isZai) {
                openZaiDrawer();
                return;
              }

              if (screens.lg) {
                setHoveredIndex(null);
                setOpenDropDown(false);
              }
            }}
          >
            {isZai ? (
              <ZaiButton />
            ) : (
              <HeaderLink
                text={link.text}
                index={index}
                open={openDropDown}
                route={link.route}
                notHaveDropDown={link?.notHaveDropDown || false}
                setOpen={setOpen}
              />
            )}

            {!isZai &&
              openDropDown &&
              hoveredIndex === index &&
              link.type &&
              screens.lg && (
                <div
                  onMouseEnter={() => {
                    if (timeoutIdRef.current)
                      clearTimeout(timeoutIdRef.current);
                  }}
                  onMouseLeave={() => {
                    setOpenDropDown(false);
                    setHoveredIndex(null);
                  }}
                  className='absolute left-0 top-full z-50'
                >
                  <ProductDropdown
                    open={openDropDown}
                    setOpen={setOpenDropDown}
                    type={link.type}
                  />
                </div>
              )}
          </div>
        );
      })}
    </span>
  );
};

export default Options;
